if (!customElements.get('m-product-video-popup')) {
  class MProductVideoPopup extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.trigger = this.querySelector('[data-product-video-trigger]');
      if (!this.trigger) return;

      this.ensurePanel();
      this.handleClick = this.openVideo.bind(this);
      this.handleClose = this.closeVideo.bind(this);
      this.trigger.addEventListener('click', this.handleClick);
      this.closeButton.addEventListener('click', this.handleClose);
    }

    disconnectedCallback() {
      if (this.trigger && this.handleClick) {
        this.trigger.removeEventListener('click', this.handleClick);
      }
      if (this.closeButton && this.handleClose) {
        this.closeButton.removeEventListener('click', this.handleClose);
      }
    }

    ensurePanel() {
      const existingPanel = document.querySelector('[data-product-video-panel]');
      if (existingPanel) {
        this.panel = existingPanel;
        this.iframe = this.panel.querySelector('[data-product-video-iframe]');
        this.closeButton = this.panel.querySelector('[data-product-video-close]');
        return;
      }

      const panel = document.createElement('div');
      panel.className = 'm-product-video-popup-panel';
      panel.hidden = true;
      panel.setAttribute('data-product-video-panel', '');
      panel.innerHTML =
        '<div class="m-product-video-popup-panel__inner">' +
        '<button type="button" class="m-product-video-popup-panel__close" data-product-video-close aria-label="Close video">&times;</button>' +
        '<iframe data-product-video-iframe src="" title="Product video" allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen></iframe>' +
        '</div>';
      document.body.appendChild(panel);
      this.panel = panel;
      this.iframe = panel.querySelector('[data-product-video-iframe]');
      this.closeButton = panel.querySelector('[data-product-video-close]');
    }

    openVideo(event) {
      event.preventDefault();

      const embedUrl = this.trigger.dataset.videoEmbed;
      const videoTitle = this.trigger.dataset.videoTitle || 'Product video';
      if (!embedUrl || !this.panel || !this.iframe) return;

      this.iframe.src = embedUrl;
      this.iframe.title = videoTitle;
      this.panel.hidden = false;
    }

    closeVideo() {
      if (!this.panel || !this.iframe) return;
      this.panel.hidden = true;
      this.iframe.src = '';
    }

    escapeAttribute(value) {
      return String(value)
        .replace(/&/g, '&amp;')
        .replace(/"/g, '&quot;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');
    }
  }

  customElements.define('m-product-video-popup', MProductVideoPopup);
}
